import * as React from 'react';
import type { SVGProps } from 'react';
const SvgVideoOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    {...props}
  >
    <g clipPath='url(#video-off_svg__a)'>
      <path
        fill='currentColor'
        d='M16 16h1a1 1 0 0 0-.293-.707zM1 17H0zM3 5V4zm2 0 .707-.707A1 1 0 0 0 5 4zm5.66-1a1 1 0 1 0 0 2zM14 5V4zm2 5.34h-1a1 1 0 0 0 .293.707zm1 1-.707.707a1 1 0 0 0 1.293.103zM23 7h1a1 1 0 0 0-1.586-.81zm-1 10a1 1 0 1 0 2 0zM1.707.293A1 1 0 0 0 .293 1.707zm20.586 23.414a1 1 0 0 0 1.414-1.414zM15 16v1h2v-1zm0 1a1 1 0 0 1-.293.707l1.414 1.414A3 3 0 0 0 17 17zm-.293.707A1 1 0 0 1 14 18v2a3 3 0 0 0 2.121-.879zM14 18H3v2h11zM3 18a1 1 0 0 1-.707-.293L.879 19.121A3 3 0 0 0 3 20zm-.707-.293A1 1 0 0 1 2 17H0a3 3 0 0 0 .879 2.121zM2 17V7H0v10zM2 7a1 1 0 0 1 .293-.707L.879 4.879A3 3 0 0 0 0 7zm.293-.707A1 1 0 0 1 3 6V4a3 3 0 0 0-2.121.879zM3 6h2V4H3zm1.293-.293 11 11 1.414-1.414-11-11zM10.66 6H14V4h-3.34zM14 6a1 1 0 0 1 .707.293l1.414-1.414A3 3 0 0 0 14 4zm.707.293A1 1 0 0 1 15 7h2a3 3 0 0 0-.879-2.121zM15 7v3.34h2V7zm.293 4.047 1 1 1.414-1.414-1-1zm2.293 1.103 6-4.34-1.172-1.62-6 4.34zM22 7v10h2V7zM.293 1.707l22 22 1.414-1.414-22-22z'
      />
    </g>
    <defs>
      <clipPath id='video-off_svg__a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgVideoOff;
